import axios from "axios";

const checkZipCode = async (zipCode: string, apiDomain: string) => {
  try {
    const { data } = await axios.get(`${apiDomain}/voebiz-utilities/v1/zipcode/check?zipcode=${zipCode}`);
    return data;
  } catch (err: any) {
    return err;
  }
};
export { checkZipCode };
